<template>
  <a-card title="批量发货" :bodyStyle="{padding:'0px 32px 24px'}" :bordered="false" :headStyle="{borderBottom:'0px'}">
    <!-- 头部组件 -->
    <BatchDelivery ref="child" @change="searchBtns"></BatchDelivery>
    <div class="install-ly">
      <a-card :bordered="false" title="批量发货记录" :bodyStyle="{padding:'0px'}"
              :headStyle="{borderBottom:'0px',paddingLeft:'0px'}">
        <a-form>
          <search-page-view
            :col="3"
            :buttonCol="2"
            ref="pageList"
            :itemNames="['search_orderNo','search_expressOrderNo','search_companyName', 'search_importDate']"
            :buttonItems="['create_button']"
            :columns="columns"
            :queryParams="queryParams"
            row-key="id"
            :leftSpace="20"
            :exportType="2"
            @export="batchExport"
            :requestPromise="loadPromise"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <a-form-item slot="search_orderNo" label="订单编号" v-bind="searchItemLayout">
              <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item slot="search_expressOrderNo" label="快递单号" v-bind="searchItemLayout">
              <a-input v-model="queryParams.expressOrderNo" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item slot="search_companyName" label="快递公司" v-bind="searchItemLayout">
              <a-input v-model="queryParams.companyName " placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item slot="search_importDate" label="导入日期" v-bind="searchItemLayout">
              <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
            </a-form-item>
            <a-button slot="create_button" type="danger" ghost @click="deleteAllEvent">批量删除</a-button>
            <span slot="action" slot-scope="rowItem">
<!--              <a @click="toEditorEvent(rowItem.record)">编辑</a>-->
              <!--              <a-divider type="vertical"></a-divider>-->
              <a-popconfirm title="是否要删除当前物流信息？" @confirm="deleteEvent(rowItem.record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </search-page-view>
        </a-form>
      </a-card>
    </div>
  </a-card>
</template>

<script>
import BatchDelivery from '../component/batchDelivery'
import searchForm from '../../../utils/mixins/searchFormMixins'

export default {
  name: 'Consignment',//批量发货
  mixins: [searchForm],
  components: {
    BatchDelivery
  },
  data() {
    return {
      selectedDate: undefined,
      queryParams: {},
      selectedRowKeys: [],
      selectedStr: '',
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '快递公司',
          dataIndex: 'companyName'
        },
        {
          title: '快递单号',
          dataIndex: 'expressOrderNo'
        },
        {
          title: '订单来源',
          dataIndex: 'orderSourceText'
        },
        {
          title: '导入时间',
          dataIndex: 'deliveryTime'
        },
        {
          title: '操作',
          width: '80px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      submitId: null,
      searchItemLayoutBtn: {
        labelCol: {
          span: 4
        },
        wrapperCol: {
          span: 20
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedStr = this.selectedRowKeys.join(',')
      this.getLogUtils().logWithTag('onSelectChange', this.selectedStr)
    },
    searchBtns() {
      this.$refs.pageList.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('api/v2/order/delivery/list', params)
    },
    //日期
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.startTime = dateStrArr[0]//出游开始日期
      this.queryParams.endTime = dateStrArr[1]//出游结束日期
    },
    createGroupEvent() {

    },
    deleteEvent(record) {
      this.deleteDelivery(String(record.id))
    },
    deleteAllEvent() {
      if (this.selectedRowKeys.length > 0) {
        this.deleteDelivery(this.selectedStr)
      } else {
        this.$message.error('请勾选列表')
      }
    },
    deleteDelivery(strIds) {
      this.getHttpServices().getOrderService().post('api/v2/order/delivery/delete', {
        ids: strIds
      }).then(res => {
        this.getLogUtils().logWithTag('==deleteDelivery==', res)
        this.searchBtns()
        this.selectedRowKeys = []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toEditorEvent(record) {
      this.getLogUtils().logWithTag('==toEditorEvent==', record)
      this.$refs.child.getCompanyInfo(record.id)
    },
    // 导出
    batchExport() {
      this.getLogUtils().logWithTag('导出参数', this.queryParams)
      this.getHttpServices().getOrderService().post('api/v2/order/delivery/export', this.queryParams).then(res => {
        this.getLogUtils().logWithTag('==batchExport==', res)
        this.$message.success('导出成功，请去报表下载中心下载')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>